<div class="subscription">
  @if (loading$ | async) {
    <pr-loader></pr-loader>
  }

  <div class="row w-1200 p-1">
    <div
      [class.toggle]="!toggle"
      class="col-xs-12 col-sm-12 col-md-12 col-lg-3 info-page"
      [ngClass]="{ postionFix: toggle }"
    >
      @if (showSidebarStepper) {
        <ea-subscription-form-stepper
          data-testid="dashboard-souscription-funnel-stepper"
          [isConsultant]="user && user?.sessionConsultant"
        ></ea-subscription-form-stepper>
      }
    </div>
    @if (toggle) {
      <div id="sidenav-overlay-info" (click)="toggle = false"></div>
    }

    <div
      class="col-xs-12 col-sm-12 col-md-12 col-lg-9 w-1200"
      style="position: relative"
    >
      <a class="btn-toggle-info" (click)="toggle = true">
        @if (pictureFile) {
          <div
            class="advisor-picture"
            [ngStyle]="{
              'background-image': 'url(' + pictureFile + ')',
            }"
          >
            <i class="fa fa-bars face"></i>
          </div>
        }
        @if (!pictureFile) {
          <span>
            <i class="fa fa-bars face"></i>
            <i class="fa fa-user-circle text-gray avatar pictureFileIcon"></i>
          </span>
        }
      </a>
      <!-- <pr-loader *ngIf="loading$ | async"></pr-loader> -->
      <div class="subscription">
        <div class="container">
          @if (question$ | async; as data) {
            @if (!data && (canSubscribe$ | async)) {
              <pr-button
                label="  Nouvelle souscription"
                (click)="openBottomSheet()"
              ></pr-button>
            }
            <router-outlet></router-outlet>
            @if (data?.category) {
              <div class="qcategory">
                <div class="question-category">
                  <div class="question-category__logo green-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="12"
                      viewBox="0 0 16 12"
                      fill="none"
                    >
                      <path
                        d="M14.3244 1.65234L5.62848 10.3483L1.67578 6.39559"
                        stroke="white"
                        stroke-width="1.58108"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div class="question-category__title">
                    <div class="question-category__title__name">
                      {{ data.category }}
                    </div>
                  </div>
                </div>
                <div class="question-category__title__questions">
                  <span> Question {{ qsIdx + 1 }} / {{ questionTotal }} </span>
                </div>
              </div>
            }
            @if (
              !!data?.getTitle?.(entity, user) ||
              !!data?.getSubTitle?.(entity, user) ||
              data.title ||
              data.subTitle
            ) {
              <question-description
                titleDir="left"
                subTitleDir="left"
                [title]="data?.getTitle?.(entity, user) || data?.title"
                [subTitle]="data?.getSubTitle?.(entity, user) || data?.subTitle"
              >
              </question-description>
              @if (error$ | async; as errorLoading) {
                <div>
                  @if (errorLoading?.error?.errors) {
                    <pr-color-panel
                      [display]="'danger'"
                      data-testid="dashboard-souscription-funnel-server-errors"
                    >
                      @for (
                        errorMessage of errorLoading?.error?.errors;
                        track errorMessage
                      ) {
                        <pr-panel-body clazz="pam">
                          <pr-label
                            [name]="'error'"
                            [width]="18"
                            [height]="18"
                            >{{ removeExtraPercent(errorMessage) }}</pr-label
                          >
                        </pr-panel-body>
                      }
                    </pr-color-panel>
                  }
                </div>
              }
            }
            <ng-container [ngTemplateOutlet]="getTemplate(data?.template)">
            </ng-container>
            @if (questions?.length == step - 1) {
              <ng-container #defaultTemplate>
                <ea-subscription-final-page></ea-subscription-final-page>
              </ng-container>
            }
          }
          <templates-component
            #cellTemplates
            id="cellTemplates"
          ></templates-component>
          @if (noPledgeFound && user?.sessionConsultant) {
            <div>
              <p>
                Il n'y a aucune souscription disponible. Cliquez
                <a (click)="navigateToSubscription()">ici</a> pour être
                redirigé(e) vers la page de souscription.
              </p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
